import React, { useState } from 'react'
import styled from 'styled-components'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const BackToTopButton = styled.button`
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #854CE6 0%, #9D5CE8 100%);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(133, 76, 230, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  opacity: ${props => props.show ? '1' : '0'};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(133, 76, 230, 0.6);
  }
  
  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
    font-size: 20px;
  }
`

const BackToTop = () => {
    const [show, setShow] = useState(false)

    React.useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 300) {
                setShow(true)
            } else {
                setShow(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    return (
        <BackToTopButton show={show} onClick={scrollToTop} aria-label="Back to top">
            <KeyboardArrowUpIcon />
        </BackToTopButton>
    )
}

export default BackToTop
